import orderBy from 'lodash/orderBy'
import lowerCase from 'lodash/lowerCase'
import { get } from 'lodash'
import { createSelector } from 'reselect'

export const sortByStringSelector = createSelector(
  [state => state?.data, state => state?.key, state => state?.order],
  (data = [], key = '', order = 'asc') => {
    if (!Array.isArray(data) || !key) {
      return []
    }

    return orderBy(data, [row => lowerCase(get(row, key))], [order])
  }
)
